"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this is used to generate a options list for the mat-select -> mat-option
const addOn_1 = require("../../../model/entity/addOn");
exports.AddOnUnitType2LabelMapping = {
    [addOn_1.AddOnUnitType.PER_TRIP]: 'Per trip',
    [addOn_1.AddOnUnitType.PER_HOUR]: 'Per hour',
    [addOn_1.AddOnUnitType.PER_PERSON]: 'Per person',
};
